export default {
  'consumption.co2': 'Рівень викидів CO2 у комбінованому циклі',
  'consumption.energy': 'Споживання електроенергії у комбінованому циклі випробувань',
  'consumption.fuel': 'Витрата палива у комбінованому циклі',
  'footnotes.local': '',
  'footnotes.wltp':
    'Вказані значення було розраховано згідно з рекомендованою процедурою вимірювання. Ідеться про «значення WLTP-CO2» згідно зі статтею 2 п. 3 Імплементаційного регламенту (ЄС) 2017/1153. Значення витрати палива розраховані на основі цих показників. Показники витрати палива розраховано згідно з Постановою 683/2008/ЄС. Дані не стосуються окремого автомобіля, не є частиною пропозиції, а наведені виключно в цілях порівняння описаних моделей. Значення варіюються залежно від обраного опціонального обладнання й можуть відрізнятися від остаточних значень замовленого або доставленого автомобіля.',
  'footnotes.nedc':
    'Вказані значення було розраховано згідно з рекомендованою процедурою вимірювання. Ідеться про «значення NEFZ-CO2» згідно зі статтею 2 п. 1 Імплементаційного регламенту (ЄС) 2017/1153. Значення витрати палива розраховані на основі цих показників. Показники витрати палива розраховано згідно з Постановою 692/2008/ЄС. Відомості не стосуються окремого автомобіля й не є частиною пропозиції, а слугують винятково для проведення порівняння між різними типами автомобілів. Значення варіюються залежно від обраного опціонального обладнання.',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Ваш пошуковий запит / Конфігуратор OnlineCode',
  'search.result.buy-online': 'Купити онлайн',
  'search.results': 'Результатів пошуку не знайдено | {count} Результат пошуку | {count} Більше результатів пошуку',
  'search.results.count': '{count} Більше результатів пошуку',
  'search.results.backup': 'Точних співпадінь, не знайдено. Переглянути схожі сторінки:',
  'search.results.none.summary':
    'З цього запиту немає результатів пошуку. Будь ласка, спробуйте ще раз з іншим пошуковим запитом.',
  'search.show-more': 'Показати більше',
  'search.unavailable': 'Наразі пошук недоступний.',
  'search.result.new': 'Новий',

  'input.placeholder': 'Ваш пошуковий запит / Конфігуратор OnlineCode',

  'suggestions.all_search_results': 'Усі результати пошуку',
  'suggestions.all_search_results_for': 'Показати всі результати для',
  'suggestions.in': 'у',

  all: 'Усі',
  UCOS: 'Used vehicle Online Store',
  PASSENGER_CARS: 'Легкові автомобілі',
  VANS: 'Мікроавтобуси',
  NCOS: 'New vehicle Online Store',
  VIDEO: 'Відео',
  DEALER_LOCATOR: 'Пошук дилера',
  CONFIGURATOR: 'Mercedes-Benz Car Configurator',
  TEST_DRIVE: 'Тест драйв',
  VEHICLE_SEARCH: 'Пошук вживаних автомобілів',
  COLLECT: 'Collection & ACCESSORIES',
  CONNECT: 'Mercedes me Store',

  'search.result.consumption': 'Споживання',
  'watch.video': 'Переглянути відео',
  'input.recently': 'Нещодавній пошук',
  'input.help.title': 'Що вам потрібно знайти?',
  'input.help.text':
    'Шукайте за типами транспортних засобів, моделями, кодами конфігурації або аксесуарами, інші вироби та інформацію',

  'search.result.grid': 'Grid',
  'search.result.list': 'List',

  // Empty result
  'support.check': 'Перевірте наявність помилок або повторіть спробу з іншим терміном.',
  'support.no.results': 'За цим пошуковим запитом не знайдено жодного результату.',
  'support.no.results.term': 'Не знайдено жодного результату.',
  'support.chat': 'Не можете знайти те, що шукаєте? Скористайтеся нашим. ',
  'support.chat.with.us': 'Підтримка в онлайн чаті.',
};
